import { LoginHintType, useLoginHint } from './login-hint';
import { useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { useNavigateSoftOrHard } from './useNavigateSoftOrHard';

export const useNavigateToLoginPrompt = () => {
  const { search } = useLocation();
  const navigate = useNavigateSoftOrHard();
  const loginHint = useLoginHint();
  const queryParams = useMemo(() => new URLSearchParams(search), [search]);

  return useCallback(() => {
    // Remove MFA transaction token
    queryParams.delete('transactionToken');

    // Remove inverted login hint
    if (loginHint?.type === LoginHintType.NotEmailAddress) {
      queryParams.delete('login_hint');
    }

    return navigate({
      pathname: '/login',
      search: `prompt=login&${queryParams}`,
    });
  }, [loginHint?.type, navigate, queryParams]);
};
